/**
 * 만료 시간이 있는 아이템을 로컬 스토리지에 저장하는 함수
 * @param {string} key - 저장할 키
 * @param {any} value - 저장할 값
 * @param {number} expiry - 만료 시간(일)
 */
export const setItemWithExpiry = (key, value, expiry) => {
  const now = new Date();
  // 현재 시간 + expiry일
  const expiryDate = now.setDate(now.getDate() + expiry);
  
  const item = {
    value: value,
    expiry: expiryDate,
  };
  
  localStorage.setItem(key, JSON.stringify(item));
};

/**
 * 로컬 스토리지에서 만료 시간이 있는 아이템을 가져오는 함수
 * 만료된 경우 해당 아이템을 삭제하고 null 반환
 * @param {string} key - 가져올 키
 * @returns {any|null} - 저장된 값 또는 null(만료된 경우)
 */
export const getItemWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  
  // 아이템이 없는 경우 null 반환
  if (!itemStr) {
    return null;
  }
  
  const item = JSON.parse(itemStr);
  const now = new Date();
  
  // 만료 시간과 현재 시간 비교
  if (now.getTime() > item.expiry) {
    // 만료된 경우 해당 아이템 삭제
    localStorage.removeItem(key);
    return null;
  }
  
  return item.value;
}; 